import styled, { css } from 'styled-components'

export const ListCard = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.sm};
`

export const ListContainer = styled.div`
  width: 240px;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: 100%;
    max-width: 100%;
  }
`

export const ListHeader = styled.div`
  padding: ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.xlarge};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
`

export const ListContent = styled.div`
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-height: 400px;
  }
`

export const ValuationItem = styled.div<{ $active: boolean; $hidden: boolean }>`
  padding: ${({ theme }) => theme.spacing.medium}
    ${({ theme }) => theme.spacing.large};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
  transition: all ${({ theme }) => theme.transitions.default};
  cursor: pointer;
  position: relative;
  opacity: ${({ $hidden }) => ($hidden ? 0.5 : 1)};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.colors.primary}0A;
      border-left: 3px solid ${theme.colors.primary};
      padding-left: calc(${theme.spacing.large} - 3px);
    `}
`

export const ValuationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};
  gap: ${({ theme }) => theme.spacing.small};
`

export const ValuationInfo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`

export const ValuationName = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`

export const TypeBadge = styled.span<{
  $type: 'avm' | 'income' | 'cost' | 'comparable' | 'manual'
}>`
  display: inline-flex;
  align-items: center;
  padding: 2px 5px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: 7px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  ${({ $type }) => {
    switch ($type) {
      case 'avm':
        return css`
          background: rgba(0, 173, 230, 0.1);
          color: #0099cc;
        `
      case 'income':
        return css`
          background: rgba(0, 179, 65, 0.1);
          color: #00994d;
        `
      case 'cost':
        return css`
          background: rgba(128, 90, 213, 0.1);
          color: #7b61ff;
        `
      case 'comparable':
        return css`
          background: rgba(52, 199, 89, 0.1);
          color: #34c759;
        `
      case 'manual':
      default:
        return css`
          background: rgba(255, 149, 0, 0.1);
          color: #ff8800;
        `
    }
  }}
`

export const ValuationActions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.micro};
  opacity: 0;
  transition: opacity ${({ theme }) => theme.transitions.default};

  ${ValuationItem}:hover & {
    opacity: 1;
  }
`

export const ConfidenceIndicator = styled.div`
  display: flex;
  gap: 2px;
`

export const ConfidenceDot = styled.div<{ $filled: boolean }>`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${({ theme, $filled }) =>
    $filled ? theme.colors.primary : theme.colors.border.default};
`

export const ValuationValues = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`

export const ValuationPrice = styled.span<{ $hidden: boolean }>`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  text-decoration: ${({ $hidden }) => ($hidden ? 'line-through' : 'none')};
`

export const ValuationRange = styled.span<{ $hidden: boolean }>`
  font-size: 10px;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-decoration: ${({ $hidden }) => ($hidden ? 'line-through' : 'none')};
`

export const AddValuationSection = styled.div`
  padding: ${({ theme }) => theme.spacing.large}
    ${({ theme }) => theme.spacing.xlarge};
  border-top: 1px solid ${({ theme }) => theme.colors.border.default};
  background: ${({ theme }) => theme.colors.background.secondary};
`

export const AddValuationButton = styled.button`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.medium};
  background: ${({ theme }) => theme.colors.background.primary};
  border: 2px dashed ${({ theme }) => theme.colors.border.default};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.default};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.small};

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
    border-color: ${({ theme }) => theme.colors.primary};
  }
`
